import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { BufferedTextInput } from 'record-it-components/input/TextInput/TextInput';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { TimeTrackingActivity } from '../../../classes/entities/TimeTrackingActivity/timeTrackingActivityTypes';
import { AnyPropertyChanged, useEntityPropertyChangedCallback } from '../../../hooks/entity/useEntityPropertyChangedCallback';
export type EditTimeTrackingActivityFormProps = PropsWithoutChildren<ComponentProps<'div'>> & {
  timeTrackingActivity: TimeTrackingActivity;
  onPropertyChanged: AnyPropertyChanged<TimeTrackingActivity>;
};
export const EditTimeTrackingActivityForm: FunctionComponent<EditTimeTrackingActivityFormProps> = React.memo(props => {
  const $ = _c(15);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let onPropertyChanged;
  let remainingProps;
  let timeTrackingActivity;
  if ($[2] !== t0) {
    ({
      timeTrackingActivity,
      onPropertyChanged,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = onPropertyChanged;
    $[4] = remainingProps;
    $[5] = timeTrackingActivity;
  } else {
    onPropertyChanged = $[3];
    remainingProps = $[4];
    timeTrackingActivity = $[5];
  }
  const {
    t
  } = useTranslation();
  const handleNameChanged = useEntityPropertyChangedCallback(timeTrackingActivity, "name", onPropertyChanged);
  let t1;
  if ($[6] !== t) {
    t1 = t("entities.TimeTrackingActivity.name");
    $[6] = t;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== handleNameChanged || $[9] !== t1 || $[10] !== timeTrackingActivity.name) {
    t2 = <BufferedTextInput label={t1} value={timeTrackingActivity.name} onInput={handleNameChanged} data-testid="EditTimeTrackingActivityForm.NameInput" />;
    $[8] = handleNameChanged;
    $[9] = t1;
    $[10] = timeTrackingActivity.name;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== remainingProps || $[13] !== t2) {
    t3 = <div {...remainingProps}>{t2}</div>;
    $[12] = remainingProps;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
});